import React, { useCallback, useEffect, useState } from 'react'
import { useDrag, useDrop } from 'react-dnd'
// import update from 'immutability-helper'
import DraggableChildComponent from './draggable-child-components'
import { RhyBusButton } from '@rhybus/button'
// import Buttons from '../../components/buttons/buttons'

interface ColumnProps {
    rowId: any,
    selectedRowId: string | undefined
    childrenData: any,
    dynamicContainerId: any,
    isDataRow?: boolean,
    isSelected: boolean;
    layout: number[] | null; // Layout determines the column classes
    onSelect: () => void;
    onChildDrop: (containerId: string, rowId: string, children: { id?: string; type?: string; label?: string; isInfo?: boolean; isMandatory?: boolean }) => void;
    onChildSelect: (childId: string | null, childType: string | null, childLabel: string | null, childInfo: boolean | null, childMandatory: boolean | null) => void;
    getChildrenLengths: any;
    formSettings: any
    getChildSelects?: any
    changedLabel?: any
    setSelectChilds?: any
    selectedContainer?: any
    setContainersData: any
    setSelectedContainer: any
    containerId: any
    clickedId?: any
    rowClassName?: string,
    selectedChildId: string | null,
    setSelectedChildId: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedWholeRowId: React.Dispatch<React.SetStateAction<string | null>>
    selectedWholeRowId: string | null
    containersData: { id: string, rowData: { id: string; childData: { id: string; type: string; label: string; isInfo: boolean; isMandatory: boolean }[]; isDataRow?: boolean }[] }[],
    setSelectedType: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedSubChild: React.Dispatch<React.SetStateAction<string | null>>
    setSelectedLayout: React.Dispatch<any>
    selectedLayout: any
    rowIndex?: number
    moveRow?: (dragIndex: number, hoverIndex: number) => void
}
const Column: React.FC<ColumnProps> = (props) => {

    const {
        selectedChildId,
        setSelectedChildId,
        rowId,
        selectedRowId,
        dynamicContainerId,
        childrenData,
        isDataRow,
        isSelected,
        layout,
        onSelect,
        onChildDrop,
        containersData,
        setSelectedSubChild,
        setSelectedType,
        setSelectedLayout,
        selectedLayout,
        getChildSelects, formSettings, setSelectChilds, setContainersData, selectedContainer, setSelectedContainer, containerId, setSelectedWholeRowId, selectedWholeRowId, rowIndex, moveRow } = props
    const [childData, setChildData] = useState<any>()
    useEffect(() => {
        setChildData(childrenData)
    }, [childrenData])
    const moveChild = useCallback((dragIndex: number, hoverIndex: number) => {
        // setChildData((prevChildData: any) =>
        //     // update(prevChildData, {
        //     //     $splice: [
        //     //         [dragIndex, 1],
        //     //         [hoverIndex, 0, prevChildData[dragIndex]],
        //     //     ],
        //     // })
        // )
        setContainersData((prevData: any) => {
            return prevData.map((container: any) => {
                if (container.id === dynamicContainerId) {
                    return {
                        ...container,
                        rowData: container.rowData.map((row: any) => {
                            if (row.id === rowId) {
                                const updatedChildren = [...row.childData]
                                const [movedItem] = updatedChildren.splice(dragIndex, 1)
                                updatedChildren.splice(hoverIndex, 0, movedItem)
                                return {
                                    ...row,
                                    childData: updatedChildren
                                }
                            }
                            return row
                        })
                    }
                }
                return container
            })
        })
    }, [])
    const handleSelectChild = (childId: string, containerId: string, rowsId: string) => {
        setSelectedChildId(childId)
        getChildSelects(childId, containerId, rowsId)
        setSelectedContainer(null)
        setSelectedWholeRowId(null)
    }

    const [{ isDraggingRow }, dragRow, dragPreview] = useDrag(() => ({
        type: 'ROW',
        item: () => ({ rowId, rowIndex }),
        collect: (monitor) => ({ isDraggingRow: monitor.isDragging() }),
    }), [rowId, rowIndex])

    const [{ isOver, canDrop }, dropRef] = useDrop(() => ({
        accept: ['CHILD', 'ROW', 'CHILDS'],
        canDrop: (_item: any) => true,
        drop: (item: any, monitor: any) => {
            if (!monitor.canDrop()) return
            // ROW drag item — handled by hover
            if ((item as any).rowId !== undefined) return
            // CHILDS drag item — existing element being moved between rows
            if ((item as any).sourceRowId !== undefined) {
                if ((item as any).sourceRowId === rowId) return  // same row, hover already handled
                const childId = (item as any).id
                setContainersData((prevData: any) => {
                    let movedChild: any = null
                    const step1 = prevData.map((container: any) => ({
                        ...container,
                        rowData: container.rowData.map((row: any) => {
                            if (row.id === (item as any).sourceRowId) {
                                movedChild = row.childData.find((c: any) => c.id === childId)
                                return { ...row, childData: row.childData.filter((c: any) => c.id !== childId) }
                            }
                            return row
                        })
                    }))
                    if (!movedChild) return prevData
                    return step1.map((container: any) => ({
                        ...container,
                        rowData: container.rowData.map((row: any) => {
                            if (row.id === rowId) {
                                return { ...row, childData: [...row.childData, movedChild] }
                            }
                            return row
                        })
                    }))
                })
                return
            }
            // CHILD drag item — new element from the sidebar
            onChildDrop(dynamicContainerId, rowId, item)
        },
        hover: (item: any) => {
            if ((item as any).rowId === undefined || !moveRow || rowIndex === undefined) return
            const dragIndex = (item as any).rowIndex as number
            const hoverIndex = rowIndex
            if (dragIndex === hoverIndex) return
            moveRow(dragIndex, hoverIndex)
            ;(item as any).rowIndex = hoverIndex
        },
        collect: (monitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    }), [rowId, isDataRow, rowIndex, moveRow, setContainersData])

    //*****  Delete Functionality *****//
    const handleDeleteContainer = (containerId: any) => {
        // Delete Selected Row
        if (selectedWholeRowId) {
            let previousRowId = null

            // Find the index of the current row
            const currentContainer = containersData.find(c => c.id === containerId)
            if (currentContainer) {
                const rowIndex = currentContainer.rowData.findIndex(r => r.id === selectedWholeRowId)

                // Determine previous row
                if (rowIndex > 0) {
                    previousRowId = currentContainer.rowData[rowIndex - 1]?.id
                } else if (currentContainer.rowData.length > 1) {
                    previousRowId = currentContainer.rowData[1]?.id
                }
            }

            const updatedContainersData = containersData.map((container) => {
                const updatedRowData = container.rowData.filter((row) => row.id !== selectedWholeRowId)
                return {
                    ...container,
                    rowData: updatedRowData,
                }
            }).filter(container => container.rowData.length > 0)

            setContainersData(updatedContainersData)

            // Focus on previous row
            if (previousRowId) {
                setSelectedWholeRowId(previousRowId)
                setSelectedChildId(null)
            } else {
                setSelectedWholeRowId(null)
                setSelectedChildId(null)
            }
        }
        // Delete Selected Child element
        if (selectedChildId) {
            const updatedContainersData = containersData.map((container) => {
                const updatedRowData = container.rowData.map((row) => {
                    const updatedChildData = row.childData.filter((child) => child.id !== selectedChildId)
                    return { ...row, childData: updatedChildData }
                })
                return {
                    ...container,
                    rowData: updatedRowData,
                }
            })
            setContainersData(updatedContainersData)
        }
        // Delete selected container 
        if (selectedContainer === containerId) {
            setSelectedContainer(null)
        }
    }

    return (
        <>

            <div ref={dropRef} id={rowId} key={rowId} className={`row p-relative mx-0 ${props?.rowClassName} ${formSettings.gutterspace.value ? formSettings.gutterspace.value : 'g-2'} ${formSettings.fontfamily.value ? formSettings.fontfamily.value : ''} ${formSettings.fontcolor.value ? formSettings.fontcolor.value : ''} ${formSettings.fontsize.value ? formSettings.fontsize.value : ''} ${isSelected ? 'border-radius border-primary' : 'border-radius border-1 align-items-end'} ${isOver && canDrop ? 'bgcolor-primary-light' : ''}`}
                onClick={(e) => {
                    e.stopPropagation()
                    setSelectedWholeRowId(rowId)
                    onSelect()
                    setSelectedChildId(null)
                }}
            >
                <div
                    ref={dragRow}
                    className="row-drag-handle"
                    title="Drag to reorder row"
                    onClick={(e) => e.stopPropagation()}
                >⠿</div>
                {childData?.length > 0 && childData?.map((child: any, index: any) => (
                    <DraggableChildComponent
                        key={child.id}
                        child={child}
                        index={index}
                        moveChild={moveChild}
                        selectedChildId={selectedChildId}
                        handleSelectChild={handleSelectChild}
                        formSettings={formSettings}
                        setSelectedChildId={setSelectedChildId}
                        setSelectedWholeRowId={setSelectedWholeRowId}
                        selectedWholeRowId={selectedWholeRowId}
                        containersData={containersData}
                        rowId={rowId}
                        selectedRowId={selectedRowId}
                        childrenData={childrenData}
                        dynamicContainerId={dynamicContainerId}
                        isSelected={isSelected}
                        layout={layout}
                        setSelectChilds={setSelectChilds}
                        setContainersData={setContainersData}
                        setSelectedContainer={setSelectedContainer}
                        containerId={containerId}
                        setSelectedSubChild={setSelectedSubChild}
                        setSelectedType={setSelectedType}
                        getChildSelects={getChildSelects}
                        selectedLayout={selectedLayout}
                        setSelectedLayout={setSelectedLayout}
                    />
                ))}
                {childData?.length === 0 && (
                    <div className="empty-placeholder pb-2">{isDataRow ? 'Add data here' : 'Drop components here'}</div>
                )}
                {isSelected && <div className='row-delete mt-0 px-0'>
                    <RhyBusButton
                       variant='text'
                        aria-label="Delete"
                        leftIcon="icon-rb-trashbin font-10"
                        className='btn-xs w-100 btn-top-left-radius-0 btn-bottom-left-radius-0 p-1 btn-border1 bgcolor-primary whitetext border-radius d-flex font-0'
                        onClick={() => handleDeleteContainer(dynamicContainerId)}
                    />
                </div>
                }
            </div>
        </>
    )
}
export default Column
